<template>
  <div
    class="operation-statement"
    :class="{ 'operation-statement-store': isStore }"
  >
    <HeaderBar />
    <div class="header">
      <h1 class="title">经营报表</h1>
      <div>
        <VzanSearchBox
          ref="searchBoxRef"
          :search-opts="searchOpts"
          :filter-panel-opts="filterPanelOpts"
          @search="handleConfirmPopup"
        >
        </VzanSearchBox>
      </div>
      <!--      <p class="time">数据更新于 2024 年 12 月 24 日 12:32</p>-->
    </div>
    <div class="total-bar">
      <span class="text">总计</span>
      <div class="right">
        <p class="num">{{ reportData.orderNum }}<span class="unit">笔</span></p>
        <p class="v-line"></p>
        <p class="num">
          ¥{{
            reportData.totalAmount ? NP.divide(reportData.totalAmount / 100) : 0
          }}
        </p>
      </div>
    </div>
    <div class="module-wrap">
      <div v-for="(item, index) in labelList" :key="index" class="module-box">
        <span :class="['dot', 'dot-' + item.key]"></span>
        <p class="label">{{ item.name }}</p>
        <div class="bottom">
          <p class="num">
            {{ reportData[`${item.key}OrderNum`] }}<span class="unit">笔</span>
          </p>
          <p class="v-line"></p>
          <p class="num">
            ¥{{
              reportData[`${item.key}Amount`]
                ? NP.divide(reportData[`${item.key}Amount`], 100)
                : 0
            }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderBar from './components/HeaderBar'
import { getOrderPerformanceSum } from '../../utils/http/modules/agent/order'
import { getOrderPerformanceSumByStore } from '@store/api/statistics.api'
import NP from 'number-precision'
import { getSession } from '@/utils/utils'
import {
  ORDER_LIST,
  DELIVERY_TYPE,
  DELIVERY_LIST,
  VERIFY_STATUS_LIST,
  ORDER_TYPE_LIST,
  ORDER_TYPE_ORDER_AND_OPERATION,
} from './js/enum'
import { mapGetters } from 'vuex'
import muTypes from '@/store/mutation-types.js'
import { agentCommonInfoMixins } from './js/mixins'
import { getWeChatSignature } from '@/utils/wxconfig'
// 大健康 - 门店系统相关控制器与组件
import StoreController from '@/controllers/storeController/view/store/store.controller.js'
import VzanSearchBox from '@/components/VzanSearchBox/index.vue'
import {
  FILTER_PANEL_OPT_TYPE,
  OTHER_TYPE,
  SEARCH_BOX_TYPE,
  DATE_TYPE,
} from '@/components/VzanSearchBox/enum'
import moment from 'moment'

export default {
  name: 'OperationStatement',
  props: {
    isComponent: Boolean,
    storeId: {
      type: Number,
    },
  },
  mixins: [agentCommonInfoMixins],
  components: { VzanSearchBox, HeaderBar },
  data() {
    return {
      searchParams: {},
      NP,
      reportData: {},
      agentSetting: {},
      authData: {},
      levelList: [],
      searchOpts: [
        [
          {
            type: SEARCH_BOX_TYPE.FILTER,
            span: 24,
            smallSize: false,
          },
        ],
      ],
    }
  },
  computed: {
    filterPanelOpts() {
      let res = [
        {
          filterType: FILTER_PANEL_OPT_TYPE.DATE,
          multiple: false,
          props: 'dateParam',
          label: '下单时间',
          dateType: DATE_TYPE.DATETIME,
          options: [
            {
              value: [
                moment(new Date()).format('YYYY-MM-DD 00:00:00'),
                moment(new Date()).format('YYYY-MM-DD 23:59:59'),
              ],
              name: '今日',
            },
            {
              value: [
                moment(new Date())
                  .subtract(3 - 1, 'days')
                  .format('YYYY-MM-DD 00:00:00'),
                moment(new Date()).format('YYYY-MM-DD 23:59:59'),
              ],
              name: '近 3 天',
            },
            {
              default: true,
              value: [
                moment(new Date())
                  .subtract(7 - 1, 'days')
                  .format('YYYY-MM-DD 00:00:00'),
                moment(new Date()).format('YYYY-MM-DD 23:59:59'),
              ],
              name: '近 7 天',
            },
            {
              value: [
                moment(new Date())
                  .subtract(30 - 1, 'days')
                  .format('YYYY-MM-DD 00:00:00'),
                moment(new Date()).format('YYYY-MM-DD 23:59:59'),
              ],
              name: '近 30 天',
            },
            {
              value: OTHER_TYPE.CUSTOM_DATE,
              name: '自定义',
              defaultBeginDate: moment(new Date()).format(
                'YYYY-MM-DD HH:mm:00'
              ),
              defaultEndDate: moment(new Date()).format('YYYY-MM-DD HH:mm:59'),
            },
          ],
        },
        {
          multiple: true,
          props: 'deliveryTypeList',
          label: '配送方式',
          options: DELIVERY_LIST.map(item => {
            if (item.value === -1) {
              return {
                ...item,
                isAll: true,
              }
            } else {
              return {
                ...item,
              }
            }
          }),
        },
        {
          multiple: true,
          props: 'orderStatusList',
          label: '订单状态',
          options: ORDER_LIST.filter(
            item =>
              item.deliveryType == DELIVERY_TYPE.COMMODITY_DISTRIBUTION ||
              item.name == '全部'
          ).map(item => {
            if (item.value === -999) {
              return {
                ...item,
                isAll: true,
              }
            } else {
              return {
                ...item,
              }
            }
          }),
        },
        {
          multiple: true,
          props: 'verifyStatusList',
          label: '订单核销状态',
          tipPlacement: 'bottom-start',
          tipWord: [
            '未核销：订单中所有的核销码都为未核销',
            '已核销：订单中所有的核销码都为已核销',
            '部分核销：订单中的核销码只有未核销/已核销',
            '已退款：订单中所有的核销码都为已退款',
            '已过期：订单中所有的核销码都为已过期',
            '部分退款：订单中有任意一个核销码为已退款状态，但并非全部核销码都为已退款状态（优先级较【退款中】、【部分过期】都高）',
            '退款中：订单中任意一个核销码为退款中的状态（优先级较【部分过期】高）',
            '部分过期：订单中有任意一个核销码为已过期的状态，但并非全部核销码都为已过期状态',
          ],
          options: VERIFY_STATUS_LIST.map(item => {
            if (item.value === -1) {
              return {
                ...item,
                isAll: true,
              }
            } else {
              return item
            }
          }),
        },
        {
          multiple: true,
          props: 'orderSegmentType',
          label: '订单类型',
          options: [...ORDER_TYPE_LIST, ...ORDER_TYPE_ORDER_AND_OPERATION].map(
            item => {
              if (item.value === null) {
                return {
                  isAll: true,
                  ...item,
                }
              } else if (
                [200, 1227, 240, 1212, 1288, 1211].includes(item.value)
              ) {
                return { ...item, default: true }
              } else {
                return item
              }
            }
          ),
        },
        {
          props: 'isAgentTakeOrder',
          label: '是否代客下单',
          options: [
            { name: '全部', value: -1 },
            { name: '是', value: 1 },
            { name: '否', value: 0 },
          ],
        },
      ]
      return res
    },
    labelList() {
      return ORDER_LIST.filter(
        item =>
          item.name != '全部' &&
          item.deliveryType == DELIVERY_TYPE.COMMODITY_DISTRIBUTION
      )
    },
    ...mapGetters(['orderFilterParamsNew']),
    // * 当前是否门店系统客户模块
    isStore() {
      return StoreController.isStore()
    },
  },
  async mounted() {
    getWeChatSignature()
    this.searchParams = await this.$refs.searchBoxRef.getParamsAsync()
    if (getSession('orderFilterParams')) {
      this.$store.commit(
        muTypes.updateOrderFilterParamsNew,
        getSession('orderFilterParams')
      )
      const {
        dateParam: cacheDateParam,
        deliveryTypeList,
        orderSegmentType,
        verifyStatusList,
        isAgentTakeOrder,
        orderStatusList,
      } = this.orderFilterParamsNew
      this.searchParams = Object.assign(this.searchParams, {
        dateParam: this.orderFilterParamsNew[cacheDateParam],
        deliveryTypeList,
        orderSegmentType,
        orderStatusList,
        verifyStatusList,
        isAgentTakeOrder,
      })
      this.$refs.searchBoxRef.setDefaultOptions(this.searchParams)
    }
    this.handleDisplayLevelList(() => {
      this._getOrderPerformanceSum()
    })
  },
  // beforeDestroy() {
  //   this.orderFilterParamsNew.deliveryType = -1
  //   this.orderFilterParamsNew.orderStatus = -999
  //   this.orderFilterParamsNew.orderSegmentType = [
  //     200, 1227, 240, 1212, 1288, 1211, 1315,
  //   ]
  //   this.$store.commit(muTypes.updateOrderFilterParams, this.orderFilterParamsNew)
  // },
  methods: {
    handleDisplayLevelList(callback) {
      this.fetchGetAgentAuth(data => {
        this.authData = data
        this.orderFilterParamsNew.followLevel = this.authData.level
        this.fetchGetAgentSetting(dataObj => {
          this.agentSetting = dataObj
          // 处理等级列表展示
          this.handleLevelDisplay(
            levelList => {
              this.levelList = levelList
              if (this.authData.level == 1) {
                this.orderFilterParamsNew.followType = 1
              }
              typeof callback === 'function' && callback()
            },
            this.authData,
            this.agentSetting
          )
        })
      })
    },
    async getCommonParams() {
      let params = {
        storeId: this.storeId > 0 ? +this.storeId : undefined,
        isStoreProductStat: this.storeId > 0 ? 1 : 0,
        ...this.searchParams,
        ...this.orderFilterParamsNew,
      }
      if (this.orderFilterParamsNew) {
        if (params.isAgentTakeOrder && Array.isArray(params.isAgentTakeOrder)) {
          params.isAgentTakeOrder = params.isAgentTakeOrder[0]
        }
      }
      if (params.dateParam && !Array.isArray(params.dateParam)) {
        params.startTime = params[params.dateParam][0]
        params.endTime = params[params.dateParam][1]
      } else if (params.dateParam && Array.isArray(params.dateParam)) {
        params.startTime = params.dateParam[0]
        params.endTime = params.dateParam[1]
      }
      if (
        params.deliveryTypeList.length === 1 &&
        params.deliveryTypeList[0] === -1
      ) {
        params.deliveryTypeList = []
      }
      if (
        params.orderSegmentType.length === 1 &&
        params.orderSegmentType[0] === null
      ) {
        params.orderSegmentType = []
      }
      if (
        params.orderStatusList.length === 1 &&
        params.orderStatusList[0] === -999
      ) {
        params.orderStatusList = []
      }
      if (
        params.verifyStatusList.length === 1 &&
        params.verifyStatusList[0] === -1
      ) {
        params.verifyStatusList = []
      }
      return params
    },
    handleConfirmPopup(searchParams) {
      if (searchParams) {
        this.searchParams = searchParams
        this.searchParams.startTime = searchParams.dateParam[0]
        this.searchParams.endTime = searchParams.dateParam[1]
        this.searchParams.isAgentTakeOrder = searchParams.isAgentTakeOrder[0]
        // if (
        //   this.searchParams.deliveryTypeList.length === 1 &&
        //   this.searchParams.deliveryTypeList[0] === -1
        // ) {
        //   this.searchParams.deliveryTypeList = []
        // }
        // if (
        //   this.searchParams.orderSegmentType.length === 1 &&
        //   this.searchParams.orderSegmentType[0] === null
        // ) {
        //   this.searchParams.orderSegmentType = []
        // }
        // if (
        //   this.searchParams.orderStatusList.length === 1 &&
        //   this.searchParams.orderStatusList[0] === -999
        // ) {
        //   this.searchParams.orderStatusList = []
        // }
        // if (
        //   this.searchParams.verifyStatusList.length === 1 &&
        //   this.searchParams.verifyStatusList[0] === -1
        // ) {
        //   this.searchParams.verifyStatusList = []
        // }
      }
      this.$nextTick(() => {
        this.$store.commit(
          muTypes.updateOrderFilterParams,
          Object.assign(this.orderFilterParamsNew, this.searchParams)
        )
        this._getOrderPerformanceSum()
      })
    },
    async _getOrderPerformanceSum() {
      const params = await this.getCommonParams()
      console.log(params, '==---')

      try {
        const $api = this.isStore
          ? getOrderPerformanceSumByStore
          : getOrderPerformanceSum
        const { dataObj } = await $api(params)
        this.reportData = dataObj || {}
      } catch (e) {
        e && this.$toast(e)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.operation-statement {
  width: 100%;
  background: rgba(245, 247, 250, 0.44)
    url('../../assets/images/agent/lower-bg.png') no-repeat center top;
  background-size: 100% 340px;
  min-height: 100vh;
  padding: 0 10px 20px;
  box-sizing: border-box;
  &.operation-statement-store {
    background: var(--primary-background-linear-gradient);
    background-repeat: no-repeat;
  }
}
.header {
  width: 100%;
  padding: 20px 0 0 12px;
  box-sizing: border-box;
  margin-bottom: 16px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .title {
    font-family: PingFang SC, PingFang SC;
    font-weight: 550;
    font-size: 16px;
    color: #202124;
    line-height: 24px;
  }
  .time {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 13px;
    color: #60646b;
    line-height: 20px;
    margin-top: 2px;
  }
}
.total-bar {
  width: 100%;
  padding: 16px;
  box-sizing: border-box;
  background: #ffffff;
  border-radius: 12px 12px 12px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  .text {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #919499;
    line-height: 22px;
  }
  .right {
    display: flex;
    align-items: center;
    .v-line {
      width: 1px;
      height: 12px;
      background: #edeff2;
      margin: 0 12px;
    }
    .num {
      display: flex;
      align-items: flex-end;
      font-family: TG-TYPE-Bold;
      font-weight: bold;
      font-size: 18px;
      color: #202124;
      line-height: 24px;
      .unit {
        font-family: TG-TYPE-Bold;
        font-weight: 400;
        font-size: 12px;
        color: #60646b;
        line-height: 22px;
        margin-left: 4px;
      }
    }
  }
}
.module-wrap {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 8px;
  box-sizing: border-box;
  .module-box {
    padding: 16px 0 16px 16px;
    box-sizing: border-box;
    position: relative;
    height: 84px;
    background: #ffffff;
    border-radius: 10px 10px 10px 10px;
    .dot {
      position: absolute;
      left: 0;
      top: 20px;
      width: 3px;
      height: 12px;
      background: #006cff;
      border-top-right-radius: 3px;
      border-bottom-right-radius: 3px;
      &-noPay {
        background: #ffa800;
      }
      &-noShipments {
        background: #ff4444;
      }
      &-shipped {
        background: #00b849;
      }
      &-finish {
        background: #006cff;
      }
      &-refund {
        background: #b8babf;
      }
      &-cancel {
        background: #b8babf;
      }
    }
    .label {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 13px;
      color: #919499;
      line-height: 20px;
      margin-bottom: 5px;
    }
    .bottom {
      display: flex;
      align-items: center;
      .v-line {
        width: 1px;
        height: 12px;
        background: #edeff2;
        margin: 0 12px;
      }
      .num {
        display: flex;
        align-items: flex-end;
        font-family: TG-TYPE-Bold;
        font-weight: bold;
        font-size: 18px;
        color: #202124;
        line-height: 24px;
        &:last-of-type {
          .unit {
            margin-right: 4px;
          }
        }
        .unit {
          font-family: TG-TYPE-Bold;
          font-weight: 400;
          font-size: 12px;
          color: #60646b;
          line-height: 22px;
          margin-left: 4px;
        }
      }
    }
  }
}
</style>
